import React, {
    useEffect,
    useState
} from "react";

import axios from "axios";

import "./JourneyHero.css";

import {

    Trophy,

    Flame,

    Star,

    TrendingUp

} from "lucide-react";

const JourneyHero = () => {

    const email =
        localStorage.getItem(
            "user_email"
        );

    const [profile,setProfile] =
        useState(null);

    const [journey,setJourney] =
        useState(null);

    useEffect(()=>{

        loadData();

    },[]);

    const loadData = async()=>{

        try{

            const [

                profileRes,

                journeyRes

            ] = await Promise.all([

                axios.get(

                    `/api/ignite/profile/${email}`

                ),

                axios.get(

                    `/api/ignite/journey/${email}`

                )

            ]);
             console.log("Profile Response:", profileRes.data);
            console.log("Journey Response:", journeyRes.data);

            setProfile(

                profileRes.data

            );

            setJourney(

                journeyRes.data

            );

        }

        catch(err){

            console.error(err);

        }

    };

    if(!profile || !journey){

        return(

            <div className="journey-hero">

                Loading...

            </div>

        );

    }
    const summary = profile?.summary || {};

const objectives = journey?.levelObjectives || {};

    return(

        <div className="journey-hero">

            <div className="journey-left">

                <span className="journey-badge">

                    Level {objectives.currentLevel}

                </span>

                <h1>

                    Ignite Journey

                </h1>

                <p>

                    Complete objectives, unlock rewards and become an Elite Performer.

                </p>

            </div>

            <div className="journey-right">

                <div className="hero-stat">

                    <Trophy size={22}/>

                    <div>

                        <span>

                            Current Level

                        </span>

                        <strong>

                            {summary.currentLevel}

                        </strong>

                    </div>

                </div>

                <div className="hero-stat">

                    <Flame size={22}/>

                    <div>

                        <span>

                            Daily Streak

                        </span>

                        <strong>

                            {summary.currentStreak} Days

                        </strong>

                    </div>

                </div>

                <div className="hero-stat">

                    <Star size={22}/>

                    <div>

                        <span>

                            XP Earned

                        </span>

                        <strong>

                            {summary.totalXP}

                        </strong>

                    </div>

                </div>

                <div className="hero-stat">

                    <TrendingUp size={22}/>

                    <div>

                        <span>

                            Journey Progress

                        </span>

                        <strong>

                            {objectives.progress}%

                        </strong>

                    </div>

                </div>

            </div>

        </div>

    );

};

export default JourneyHero;